import type { JSX } from 'react';
import './ChapbookDivider.css';

/**
 * Chapbook section break — the hand-drawn printer's ornament used between
 * stacked title-plate elements (e.g. between a role plate and the secret-word
 * sentence on the GhostMeeting recto). Painted via mask-image + currentColor,
 * so placing this inside a POV-themed page picks up the right ink token
 * without needing a prop.
 *
 * Per DESIGN.md §6 the chapbook divider earns its weight by rarity; reach
 * for this only where a printed-page section break is the right register.
 * The Wordmark and SignatureBand carry variants of the same ornament for
 * their slots; this is the unadorned form for cross-phase reuse.
 */
export function ChapbookDivider(): JSX.Element {
  return <span className="susdle-chapbook-divider" aria-hidden />;
}
